<div [class]="wrapperClass()" (click)="clicked()">
    <img *ngIf="leftIcon" [src]="leftIcon" class="leftIcon" [alt]="text + ' Icon'" />
    {{text}}
    <img *ngIf="rightIcon" [src]="rightIcon" class="rightIcon" [alt]="text + ' Icon'" />
</div>